import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    list: [],
    pagination: {},
    filters: null,
  },
  getters: {
    list(state) {
      return state.list
    },
    pagination(state) {
      return state.pagination
    },
    filters(state) {
      return state.filters
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setPagination(state, data) {
      state.pagination = data
    },
    setFilters(state, data) {
      state.filters = data
    },
  },
  actions: {
    async loadRatingHistory({ commit }, params = {}) {
      const url = process.env.NODE_ENV === 'production' ? '/api/lk/leads/reputation-history' : '/api/lk/reputationHistory.json'

      const { history, pagination, filters } = await Vue.http.get(url, { params }).then(res => ({
        history: res?.body?.history ?? [],
        pagination: res?.body?.pagination ?? {},
        filters: res?.body?.filter ?? [],
      }))

      commit('setList', history)
      commit('setPagination', pagination)
      commit('setFilters', filters)
    },
  },
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/lk-rating-history.js